import type { AuthApiAdmin } from './types.js';

export const useAuthAdminApi = (): AuthApiAdmin => {
  const userAdminStore = useUserAdminStore();

  const { clearTokenCookies, setTokenCookies, setCurrencyCookies } = useAuthAdminHelpers();


  const login = async (
    { email, password, withUserData = false, withAccountData = false }: LoginRequest,
    useStore = true
  ): Promise<boolean | undefined> => {
    const userAdminStore = useUserAdminStore ();
    const runtimeConfig = useRuntimeConfig();
    // Supprimer l'appel automatique à logout() qui supprimait les cookies
    // await logout();

    try {
      const params = new URLSearchParams();

      const url = `/api/admin/auth/login?${params.toString()}`;

      // Make API call to login endpoint
      const { data, error } = await useFetch<LoginResponse>(url, {
        method: 'POST',
        body: {
          email: email,
          password: password,
        },
      });

      if (error.value) {
        throw new Error(error.value.data.message || 'Login failed.');
      }

      const response: LoginResponse | null = data.value;
      if (response?.success) {
        // Set token in cookies
        setTokenCookies(response.data.token);

        // Update user store if necessary
        if (useStore) {
          userAdminStore.login({
            user: response.data.userData ? response.data.userData.user : response.user,
            currency: runtimeConfig.public.currency,
          });
        }

        // Redirect user after successful login
        console.log('response.success', response.success);
        return response.success;
      }
    } catch (error) {
      console.error('Failed to login:', error);
      throw new Error(error as string || 'Login failed.');
    }
  };

  const logout = async () => {
    try {
      // à ajouter API call to logout endpoint
      clearTokenCookies();
      userAdminStore.logout();
    } catch (error) {
      console.error('Failed to logout:', error);
    }
  };

  const sendResetPasswordEmail = async (email: string): Promise<SendResetPasswordEmailResponse> => {
    try {
      const { data, error } = await useFetch<SendResetPasswordEmailResponse>(
        '/api/auth/send-reset-password-email',
        {
          method: 'POST',
          body: { email },
        }
      );

      if (error.value) throw new Error(error.value.message);

      return data.value
        ? data.value
        : { success: false, message: 'Failed to send reset password email.' };
    } catch (err) {
      return {
        success: false,
        message: err instanceof Error ? err.message : 'An error occurred',
      };
    }
  };

  const resetPassword = async (
    newPassword: string,
    resetPasswordToken: string
  ): Promise<ResetPasswordResponse> => {
    try {
      const { data, error } = await useFetch<ResetPasswordResponse>('/api/auth/reset-password', {
        method: 'POST',
        body: { newPassword, resetPasswordToken },
      });

      if (error.value) throw new Error(error.value.message);

      return data.value ? data.value : { success: false, message: 'Failed to reset password.' };
    } catch (err) {
      return {
        success: false,
        message: err instanceof Error ? err.message : 'An error occurred',
      };
    }
  };

  const getAuthenticatedUser = async (useStore?: boolean): Promise<any | null> => {
    try {
      // TODO: Implement getAuthenticatedUser logic
      console.warn('getAuthenticatedUser not implemented yet');
      return null;
    } catch (error) {
      console.error('Failed to get authenticated user:', error);
      return null;
    }
  };

  const getStores = async () => {
    try {
      const storyStore = useStoryblokStore();
      const story = await useAsyncStoryblok('stores', {
        version: 'published',
      });
      if (story?.value) {
        storyStore.setStory('stores', story.value?.content?.Stores);
      }
      return story.value?.content?.Stores;
    } catch (error) {
      console.error('Failed to get stores:', error);
      return null;
    }
  };

  return { getAuthenticatedUser, login, logout, sendResetPasswordEmail, resetPassword, getStores };
};
